module.exports = __webpack_public_path__ + "img/b_intro_5_cn.85c3b1f.png";